/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendQuoteRequest
 */
export interface SendQuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof SendQuoteRequest
     */
    adminComment?: string;
}

/**
 * Check if a given object implements the SendQuoteRequest interface.
 */
export function instanceOfSendQuoteRequest(value: object): value is SendQuoteRequest {
    return true;
}

export function SendQuoteRequestFromJSON(json: any): SendQuoteRequest {
    return SendQuoteRequestFromJSONTyped(json, false);
}

export function SendQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendQuoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
    };
}

export function SendQuoteRequestToJSON(value?: SendQuoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'adminComment': value['adminComment'],
    };
}

